import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./PriceList.css";

const PriceList = () => {
  return (
    <Container>
      <Row>
        <Col id="pricing">
          <h1 className="price-list-h1-mini">Cennik usług</h1>
          <h1 className="price-list-h1">
            Oferta <span className="price-list-span">personalizacji</span>{" "}
            legitymacji szkolnych ucznia <br />i służbowej nauczyciela
          </h1>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">MEiN-I/1, EDU-I/1</h3>
          <h2 className="price-list-h2">10 zł</h2>
          <p>
            Cena zawiera: <strong>Personalizacja</strong> +{" "}
            <strong>blankiet</strong> legitymacji ucznia.
          </p>
          <p>
            Czas realizcji <strong>2 dni</strong> robocze.
          </p>
          <p>Możesz złożyć zamówienie na dowolną ilość legitymacji.</p>
          <Button
            className="price-list-button"
            href="https://backend.strefadlaedukacji.pl/site/index"
          >
            Złóż Zamówienie
          </Button>
        </Col>
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">MEiN-I/2, EDU-I/2</h3>
          <h2 className="price-list-h2">10 zł</h2>
          <p>
            Cena zawiera: <strong>Personalizacja</strong> + blankiet legitymacji
            ucznia.
          </p>
          <p>
            Czas realizcji <strong>2 dni</strong> robocze.
          </p>
          <p>Możesz złożyć zamówienie na dowolną ilość legitymacji.</p>
          <Button
            className="price-list-button"
            href="https://backend.strefadlaedukacji.pl/site/index"
          >
            Złóż Zamówienie
          </Button>
        </Col>
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">MEiN-I/3-N, EDU-I/3-N</h3>
          <h2 className="price-list-h2">10 zł</h2>
          <p>
            Cena zawiera: <strong>Personalizacja</strong> + blankiet legitymacji
            ucznia.
          </p>
          <p>
            Czas realizcji <strong>2 dni</strong> robocze.
          </p>
          <p>Możesz złożyć zamówienie na dowolną ilość legitymacji.</p>
          <Button
            className="price-list-button"
            href="https://backend.strefadlaedukacji.pl/site/index"
          >
            Złóż Zamówienie
          </Button>
        </Col>
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">MEiN-I/4-N, EDU-I-4/N</h3>
          <h2 className="price-list-h2">10 zł</h2>
          <p>
            Cena zawiera: <strong>Personalizacja</strong> + blankiet legitymacji
            ucznia.
          </p>
          <p>
            Czas realizcji <strong>2 dni</strong> robocze.
          </p>
          <p>Możesz złożyć zamówienie na dowolną ilość legitymacji.</p>
          <Button
            className="price-list-button"
            href="https://backend.strefadlaedukacji.pl/site/index"
          >
            Złóż Zamówienie
          </Button>
        </Col>
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">Służbowa Nauczyciela</h3>
          <h2 className="price-list-h2">15 zł</h2>
          <p>
            Cena zawiera: <strong>Personalizacja</strong> + blankiet legitymacji
            nauczyciela.
          </p>
          <p>
            Czas realizcji <strong>2 dni</strong> robocze.
          </p>
          <p>Możesz złożyć zamówienie na dowolną ilość legitymacji.</p>
          <Button
            className="price-list-button"
            href="https://backend.strefadlaedukacji.pl/"
          >
            Złóż Zamówienie
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <h1 className="price-list-h1">
            Oferta <span className="price-list-span">blankietów</span>{" "}
            legitymacji szkolnych ucznia <br />i służbowej nauczyciela
          </h1>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">EDU-I/1</h3>
          <h2 className="price-list-h2">5,00 zł</h2>
          <p>Blankiet legitymacji ucznia.</p>
          <p>Możesz zamówić dowolną ilość blankietów.</p>
          <p>
            Legitymacja szkolna dla uczniów szkół dla dzieci i młodzieży oraz
            uczniów szkół polskich.
          </p>
          <Button className="price-list-button" href="/zamowienie-blankietow">
            Złóż Zamówienie
          </Button>
        </Col>
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">EDU-I/2</h3>
          <h2 className="price-list-h2">5,00 zł</h2>
          <p>Blankiet legitymacji ucznia.</p>
          <p>Możesz zamówić dowolną ilość blankietów.</p>
          <p>
            Legitymacja szkolna dla słuchaczy branżowych szkół II stopnia, szkół
            policealnych i szkół dla dorosłych.
          </p>
          <Button className="price-list-button" href="/zamowienie-blankietow">
            Złóż Zamówienie
          </Button>
        </Col>
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">EDU-I/3-N</h3>
          <h2 className="price-list-h2">5,00 zł</h2>
          <p>Blankiet legitymacji ucznia.</p>
          <p>Możesz zamówić dowolną ilość blankietów.</p>
          <p>
            Legitymacja szkolna dla niepełnosprawnych uczniów szkół dla dzieci i
            młodzieży oraz uczniów szkół polskich.
          </p>
          <Button className="price-list-button" href="/zamowienie-blankietow">
            Złóż Zamówienie
          </Button>
        </Col>
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">EDU-I/4-N</h3>
          <h2 className="price-list-h2">5,00 zł</h2>
          <p>Blankiet legitymacji ucznia.</p>
          <p>Możesz zamówić dowolną ilość blankietów.</p>
          <p>
            Legitymacja szkolna dla niepełnosprawnych słuchaczy branżowych szkół
            II stopnia, szkół policealnych i szkół dla dorosłych.
          </p>
          <Button className="price-list-button" href="/zamowienie-blankietow">
            Złóż Zamówienie
          </Button>
        </Col>
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">Służbowa Nauczyciela</h3>
          <h2 className="price-list-h2">8,00 zł</h2>
          <p>Blankiet legitymacji służbowej nauczyciela.</p>
          <p>Możesz zamówić dowolną ilość blankietów.</p>
          <Button className="price-list-button" href="/zamowienie-blankietow">
            Złóż Zamówienie
          </Button>
        </Col>
        <hr />
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">MEiN-I/1</h3>
          <h2 className="price-list-h2">4,50 zł</h2>
          <p>Blankiet legitymacji ucznia.</p>
          <p>
            Możesz zamówić dowolną ilość blankietów. Do wyczerpania zapasów.
          </p>
          <Button className="price-list-button" href="/zamowienie-blankietow">
            Złóż Zamówienie
          </Button>
        </Col>
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">MEiN-I/3-N</h3>
          <h2 className="price-list-h2">4,50 zł</h2>
          <p>Blankiet legitymacji ucznia.</p>
          <p>
            Możesz zamówić dowolną ilość blankietów. Do wyczerpania zapasów.
          </p>
          <Button className="price-list-button" href="/zamowienie-blankietow">
            Złóż Zamówienie
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <h1 className="price-list-h1">
            Oferta <span className="price-list-span">hologramów</span> do
            legitymacji szkolnych ucznia <br />i służbowej nauczyciela
          </h1>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col
          xxl={3}
          xl={4}
          lg={4}
          md={6}
          sm={10}
          xs={10}
          className="price-list-box me-3 ms-3 my-3"
        >
          <h3 className="price-list-h3">Hologram</h3>
          <h2 className="price-list-h2">0,50 zł</h2>
          <p>Hologram do przedłużenia ważności legitymacji szkolnej.</p>
          <p>Możesz zamówić dowolną ilość hologramów.</p>
          <Button className="price-list-button" href="/zamowienie-blankietow">
            Złóż Zamówienie
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default PriceList;
